module.exports = __webpack_public_path__ + "static/media/Huimin Zhuang.cd534e8c.png";